<div *ngIf="reportType == 'briefly'">
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" [useExistingCss]="true" style="margin-top: 2%;" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint>
            print
        </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Contract_Details_Report')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="11" class="br-bottom br-top br-right">
                        सा. विवेक जाहिरात वार्षिक करार {{ fiscalYearLabel }} नोंदणी तक्ता
                    </th>
                    <th colspan="2" class="br-bottom br-top br-right">Brief</th>
                    <th colspan="2" class="br-bottom br-top"></th>
                </tr>
                <tr>
                    <th class="br-bottom br-right br-top">अक्र.</th>
                    <th class="br-bottom br-right br-top">जाहिरात कराराचे नाव</th>
                    <th class="br-bottom br-right br-top">प्रतिनिधी</th>
                    <th class="br-bottom br-right br-top">करार कालावधी</th>
                    <th class="br-bottom br-right br-top">मागील करार</th>
                    <th class="br-bottom br-right br-top">शिल्लक करार</th>
                    <th class="br-bottom br-right br-top">नवीन करार</th>
                    <th class="br-bottom br-right br-top">एजन्सी सूट</th>
                    <th class="br-bottom br-right br-top">एकूण</th>
                    <th class="br-bottom br-right br-top">जी एस टी</th>
                    <th class="br-bottom br-right br-top">एकूण</th>
                    <th class="br-bottom br-right br-top">एकूण मार्च अखेर</th>
                    <th class="br-bottom br-right br-top">पुढील वर्षासाठी</th>
                    <th class="br-bottom br-right br-top">आज अखेर वापरले</th>
                    <th class="br-bottom br-top">मार्च अखेर वापरणे बाकी</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of contractData; let i = index">
                    <td class="br-bottom br-right">{{ i+1 }}</td>
                    <td class="br-bottom br-right">{{ data['advt_name'] }}</td>
                    <td class="br-bottom br-right">{{ data['rep_name'] }}</td>
                    <td class="br-bottom br-right">{{ data['contract_period_from'] | date:"MM yyyy" }} to {{
                        data['contract_period_to'] | date:"MM
                        yyyy" }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_prev_bal'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_bal_amt'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_amt'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_discnt_amt'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_net_amt'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_net_gst_amt'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['contract_net_total'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['total_march_end'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['next_year'] }}</td>
                    <td class="br-bottom br-right" style="text-align: end;">{{ data['till_date_used'] }}</td>
                    <td class="br-bottom " style="text-align: end;">{{ data['use_till_march_end'] }}</td>
                </tr>
                <tr>
                    <td class="br-bottom br-top br-right"></td>
                    <td class="br-bottom br-top br-right">एकूण</td>
                    <td class="br-bottom br-top br-right"></td>
                    <td class="br-bottom br-top br-right"></td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{ lastcontract }}
                    </td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{remaincontract }}</td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{ newcontract }}
                    </td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{
                        agencydiscontract }}</td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{ totalcontract
                        }}</td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{ gstcontract }}
                    </td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{
                        grandtotalcontract }}</td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{
                        totalData['total_march_end'] }}</td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{
                        totalData['next_year'] }}</td>
                    <td class="br-bottom br-top br-right" style="text-align: end; font-weight: bold;">{{
                        totalData['till_date_used'] }}</td>
                    <td class="br-bottom br-top " style="text-align: end; font-weight: bold;">{{
                        totalData['use_till_march_end'] }}</td>
                </tr>
            </tbody>
        </table>

    </div>
</div>